module.exports = __webpack_public_path__ + "static/media/4.42382e7b.png";